import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_user", JSON.stringify(data.user));
      toast.success("Willkommen zurück");
      navigate("/admin");
    } catch (e) {
      const raw = e?.response?.data?.detail;
      const msg = typeof raw === "string" ? raw : "Login fehlgeschlagen";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 grid place-items-center px-4 py-16">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md rounded-3xl bg-white border border-slate-200 shadow-floating p-7 sm:p-8"
          data-testid="admin-login-form"
        >
          <div className="w-12 h-12 rounded-2xl bg-brand-navy text-white grid place-items-center mb-4">
            <Lock size={20} />
          </div>
          <h1 className="text-2xl font-heading font-bold text-slate-900">Admin-Anmeldung</h1>
          <p className="text-sm text-slate-600 mt-1">Privater Bereich – nur für Mitarbeiter.</p>

          <label className="block mt-6 text-sm font-semibold text-slate-700">Benutzername</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="mt-1 w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-brand-amber"
            data-testid="login-username"
            autoComplete="username"
          />

          <label className="block mt-4 text-sm font-semibold text-slate-700">Passwort</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-brand-amber"
            data-testid="login-password"
            autoComplete="current-password"
          />

          {error && (
            <div className="mt-4 rounded-xl bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-xl bg-brand-navy text-white px-5 py-3 font-semibold hover:bg-slate-800 disabled:opacity-60 transition-colors"
            data-testid="login-submit"
          >
            {loading && <Loader2 className="animate-spin" size={16} />} Anmelden
          </button>
        </form>
      </main>
      <SiteFooter />
    </div>
  );
}
